module.exports = __webpack_public_path__ + "img/asuka_footer_sdg.6212f6e8.png";